// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#accordion a.collapsed .fa-caret-up{\n  transform: rotate(180deg);\n}\n\n#accordion a:hover, #accordion a:focus{\n  text-decoration: none;\n}\n\n#accordion .panel-heading{\n  padding: 8px;\n}\n\n#accordion .panel-body{\n  padding: 0px;\n}", ""]);
// Exports
module.exports = exports;
